module.exports = __webpack_public_path__ + "img/bg_head3@2x.7291fb17.png";